import React, { Component } from "react";
import { leadType, offerType } from "../../app";
import FormStep from "../../common/components/formStep";
import BackContinueButton from "../../common/components/pageBlocks/backContinueButton";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import BankChargeAgree from "../../common/components/pageBlocks/loanDetails/bankChargeAgree";
import BankDetailsForm from "../../common/components/pageBlocks/loanDetails/bankDetailsForm";
import DealerConfirmationPopUp from "../../common/components/pageBlocks/loanDetails/dealerConfirmationPopUP";
import LoanDetailsForm from "../../common/components/pageBlocks/loanDetails/loanDetailsForm";
import LoanSummary from "../../common/components/pageBlocks/loanDetails/loanSummary";
import ModalPopUp from "../../common/components/pageBlocks/modalPopUp";
import VehicleUpdateCard from "../../common/components/pageBlocks/vehicleUpdateCard";
import commonContext, { AppContext } from "../../common/context/common";
import { Utilities } from "../../common/utils/utilities";
import { ALDDApis } from "../apis/aLDDApis";
import V from "../../common/constents/validation";

interface IProps {
    history: any;
}
interface IState {
    dealerConfirmationSwitch: boolean;
    LDIAgreeError?: boolean;
}
export default class LoanDetails extends Component<IProps, IState> {
    static contextType = commonContext;
    validation: Array<{
        name: string;
        valid: any;
        errorText: string;
        moreValid?: Function;
    }>;
    lead: leadType;
    offer: offerType;
    apis: ALDDApis;
    setLead: Function;
    setOffer: Function;
    utils: Utilities;
    base: string;
    leadError: object;
    setLeadError: Function;
    steps = [
        { title: "Vehicle" },
        { title: "Loan", active: true },
        { title: "Personal" },
        { title: "e-Mandate" },
        { title: "Confirmation" },
    ];
    constructor(props: IProps) {
        super(props);
        this.state = { dealerConfirmationSwitch: false, LDIAgreeError: false };
    }
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.apis = (this.context as AppContext).apis as ALDDApis;
        this.setLead = (this.context as AppContext).setLead;
        this.setOffer = (this.context as AppContext).setOffer;
        this.lead = (this.context as AppContext).lead as leadType;
        this.offer = (this.context as AppContext).offer as offerType;
        this.utils = (this.context as AppContext).utils as Utilities;
        this.base = (this.context as AppContext).base;
        this.leadError = (this.context as AppContext).leadError;
        this.setLeadError = (this.context as AppContext).setLeadError;
        var imps: Array<object> = [];
        if (this.lead.typeOfCustomer == "NTB") {
            const getIMPSDetails = await this.apis.getIMPSDetails({
                ...this.lead,
                bank: this.lead.bankName,
                branch: this.lead.bankBranchName,
            });
            if (getIMPSDetails.error?.error) {
                // error
            } else {
                imps = getIMPSDetails.result?.imps;
            }
        }

        let VDOnRoadCost =
            (this.lead.avgCost ? this.lead.avgCost : 0) -
            (this.lead.discountPrice ? parseInt(this.lead.discountPrice) : 0) +
            (this.lead.roadTaxInsuranceAvailed
                ? parseInt(this.lead.rtoEditAmount)
                : 0) +
            (this.lead.motorInsuranceAvailed
                ? this.lead.motorInsurancePremium
                    ? parseFloat(this.lead.motorInsurancePremium)
                    : parseFloat(this.lead.motorInsurancePremAmt)
                : 0) +
            (this.lead.dealerInsuranceAvailed
                ? parseInt(this.lead.dealerInsuranceAmtEdit)
                : 0);
        const finalCarPrice =
            this.lead.avgCost -
            (this.lead.discountPrice ? parseFloat(this.lead.discountPrice) : 0);
        let desiredLoanAmount = this.utils.getFinalPrice(
            this.lead.tenure,
            this.lead.upto36m,
            this.lead.M37_60,
            this.lead.M61_84,
            (finalCarPrice as unknown) as string,
            this.lead.loanAmt
        );
        const apisDatagetStampDuty = await this.apis.getStampDuty({
            ...this.lead,
            liLoanAmount: (desiredLoanAmount as unknown) as string,
            losAppId: this.lead.losAppId,
            state: this.lead.pdPresentState,
            city: this.lead.pdPresentCity,
        });
        const emi = this.utils.getEmi(
            this.lead.interestRate,
            desiredLoanAmount,
            this.lead.tenure
        );
        let totalLoanAmount =
            desiredLoanAmount +
            (this.lead.roadTaxInsuranceAvailed
                ? parseFloat(this.lead.rtoEditAmount)
                : 0) +
            (this.lead.motorInsuranceAvailed
                ? this.lead.motorInsurancePremium
                    ? parseFloat(this.lead.motorInsurancePremium)
                    : parseFloat(this.lead.motorInsurancePremAmt)
                : 0) +
            (this.lead.dealerInsuranceAvailed
                ? parseFloat(this.lead.dealerInsuranceAmtEdit)
                : 0) +
            (this.lead.insuranceAvailed
                ? parseFloat(this.lead.insuranceSsiPremium)
                : 0);
        let liLoanAmount =
            totalLoanAmount -
            (apisDatagetStampDuty?.result?.stampDuty
                ? parseFloat(apisDatagetStampDuty?.result?.stampDuty)
                : 0) -
            parseFloat(this.lead.processingFees) -
            this.lead.collateralCharges -
            (this.lead.motorInsuranceAvailed
                ? this.lead.motorInsurancePremium
                    ? parseFloat(this.lead.motorInsurancePremium)
                    : parseFloat(this.lead.motorInsurancePremAmt)
                : 0) -
            parseFloat(this.lead.insuranceSsiPremium);
        let marginMoneyPaid = finalCarPrice - desiredLoanAmount;
        this.setLead({
            VDOnRoadCost,
            emi,
            finalCarPrice,
            totalLoanAmount,
            liLoanAmount,
            marginMoneyPaid,
            desiredLoanAmount,
            loanAmtSelectedByUser: this.lead.loanAmtSelectedByUser
                ? this.lead.loanAmtSelectedByUser
                : desiredLoanAmount,
            desiredLoanAmountUpTo: desiredLoanAmount,
            liPurposeLoan: "Personal",
            preApprovedLoanAmt: this.lead.loanAmt,
            insuranceName: "servSuraksha",
            imps,
            insuranceAvailed: parseFloat(this.lead.tenure) > 60 ? false : true,
        });
    }
    handleOnSubmit = async (e) => {
        e.preventDefault();
        this.lead = (this.context as AppContext).lead as leadType;
        let step = this.lead.step == 2 ? this.lead.step : ++this.lead.step;

        // * validation code here

        this.validation = [
            V.loanAmtSelectedByUser(
                parseFloat(this.lead.desiredLoanAmountUpTo)
            ),
            V.LDIAgree,
        ];
        if (this.lead.typeOfCustomer == "NTB") {
            this.validation.push(
                ...[V.kycCompliantAgree, V.bankAccountType, V.ifsc]
            );
        }
        if (this.lead.insuranceAvailed) {
            this.validation.push(
                ...[V.insuranceNomineeName, V.insuranceNomineeRelation]
            );
        }
        console.log(this.validation);
        const errors = this.utils.formValidation(this.lead, this.validation);
        const isErrors = this.utils.checkPropertiesEmpty(errors);
        this.setLeadError(errors);
        if (!isErrors) return;
        // * validation code end
        await this.setLead({ loadingBtn: "loadingBtn" });
        const apiData = await this.apis.saveLoanInformation({
            ...this.lead,
            step: step,
            selectedAmount: this.lead.loanAmtSelectedByUser,
        });
        await this.setLead({ loadingBtn: "" });
        if (!apiData.error?.error) {
            this.props.history.push("/error");
        }
        if (!apiData.result?.error) {
            this.setLead({ step: step });
            this.props.history.push("personal-details");
        }
    };
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="vehicle-wrap mt-110">
                        <div className="container mx-auto px-5">
                            <form onSubmit={(e) => this.handleOnSubmit(e)}>
                                <FormStep steps={this.steps} />
                                <VehicleUpdateCard />
                                <LoanDetailsForm />
                                <LoanSummary />
                                {this.lead.typeOfCustomer != "ETB" ? (
                                    <BankDetailsForm />
                                ) : (
                                    ""
                                )}
                                <BankChargeAgree
                                    error={this.state.LDIAgreeError}
                                />
                                {/* <a
                                    href="javascript:;"
                                    className="blue-link-color no-underline hover:underline hover:text-black text-sm md:text-base lg:text-lg xl:text-lg transition-all modal-open"
                                    onClick={() =>
                                        this.setState({
                                            dealerConfirmationSwitch: true,
                                        })
                                    }
                                >
                                    Dealer Confirmation
                                </a> */}
                                <BackContinueButton backPath="vehicle-details" />
                            </form>
                        </div>
                    </section>
                    {this.state.dealerConfirmationSwitch ? (
                        <ModalPopUp
                            onclickhandler={() =>
                                this.setState({
                                    dealerConfirmationSwitch: false,
                                })
                            }
                        >
                            <DealerConfirmationPopUp
                                onclickhandler={() =>
                                    this.setState({
                                        dealerConfirmationSwitch: false,
                                    })
                                }
                            />
                        </ModalPopUp>
                    ) : (
                        ""
                    )}
                </div>
            </>
        );
    }
}
